<template>
  <div class="container">
    <div class="bottom">
      <baidu-map class="map" :zoom="zoom" @ready="handler" :mapStyle="mapStyle"></baidu-map>
      <div class="panel" style></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Map',
  data () {
    return {
      loading: true,
      ViewData: null,
      name: null,
      point: { lng: 0, lat: 0 },
      zoom: 20,
      show: false,
      markerPoint: { lng: 0, lat: 0 },
      mapStyle: { styleJson: [] },
      areaData: [],
      hasName: false
    }
  },
  methods: {
    handler ({ BMap, map }) {
      this.loadMapStyle()
      this.point.lng = this.$route.query.lng
      this.point.lat = this.$route.query.lat
      if (this.point.lng) {
        map.centerAndZoom(new BMap.Point(this.point.lng, this.point.lat), 14)
        var markIcon = new BMap.Icon(require('../assets/mark_0.png'), new BMap.Size(20, 20))
        var point = new BMap.Point(this.point.lng, this.point.lat)
        var marker = new BMap.Marker(point, { icon: markIcon })
        // 把标注添加到地图上
        map.addOverlay(marker)
        // 启用滚轮放大缩小
        map.enableScrollWheelZoom()

        setTimeout(function () {
          // 隐藏百度版权信息
          var objs = document.getElementsByClassName('BMap_cpyCtrl')
          for (var i = 0; i < objs.length; i++) {
            objs[i].style.display = 'none'
          }
          objs = document.getElementsByClassName('anchorBL')
          for (i = 0; i < objs.length; i++) {
            objs[i].style.display = 'none'
          }
        }, 2000)
      }
    },
    loadMapStyle () {
      var that = this
      this.$ajax.get('/static/custom_map_config.json').then(res => {
        that.mapStyle.styleJson = res.data
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="css" rel="stylesheet/scss"  scoped>
.container {
  width: 100%;
  height: calc(100% - 40px);
  background: #0b133f;
}
.top {
  height: 80px;
  width: 70%;
  margin-left: 15%;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: 100% 70px !important;
  display: flex;
  justify-content: space-between;
}
.top img {
  position: absolute;
  height: 30px;
  left: calc(50% - 150px);
  z-index: 60;
  top: 0px;
  width: 300px;
  margin-top: 30px;
  cursor: pointer;
}
.top .left {
  height: 30px;
  width: 44%;
  margin-top: 50px;
  display: inline-flex;
  z-index: 100;
}
.top .left .menu {
  height: 30px;
  width: 180px;
  background: url('../../static/menu-l.png') no-repeat;
  background-size: 180px 30px;
  color: #668eff;
  line-height: 30px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}
.top .left .active {
  color: #fff;
}
.top .left .menu:hover {
  color: #fff;
}
.top .left .menu:nth-child(2) {
  margin-left: -10px;
}
.top .right {
  height: 30px;
  width: 56%;
  margin-top: 50px;
  display: flex;
  justify-content: flex-end;
  z-index: 100;
}
.top .right .menu {
  height: 30px;
  width: 200px;
  background: url('../../static/menu-r.png') no-repeat;
  background-size: 200px 30px;
  color: #668eff;
  line-height: 30px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}
.top .right .active {
  color: #fff;
}
.top .right .menu:hover {
  color: #fff;
}
.top .right .menu:nth-child(2) {
  margin-left: -10px;
}
.bottom {
  height: 99%;
  width: 100%;
  display: inline-flex;
}
.map {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 40;
}
#zoomer {
  display: none;
}
.map span {
  display: none;
}
.map .anchorBL {
  display: none !important;
  position: absolute;
}
.BMap_cpyCtrl {
  display: none;
}
.panel {
  background: url('../../static/panel3.1.png') no-repeat;
  background-size: 200px 150px;
  position: absolute;
  bottom: 40px;
  right: 40px;
  width: 300px;
  height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/Map.vue